class PubSub {
  constructor() {
    this.subscribers = {};
  }

  subscribe(eventName, callback) {
    if (this.subscribers[eventName] === undefined) {
      this.subscribers[eventName] = [];
    }

    this.subscribers[eventName] = [...this.subscribers[eventName], callback];

    return () => {
      this.subscribers[eventName] = this.subscribers[eventName].filter((cb) => {
        return cb !== callback;
      });
    };
  }

  publish(eventName, data) {
    if (!this.subscribers[eventName]) return Promise.resolve();

    const promises = this.subscribers[eventName].map((callback) => callback(data));
    return Promise.all(promises);
  }
}

const pubSub = new PubSub();

function subscribe(eventName, callback) {
  return pubSub.subscribe(eventName, callback);
}

function publish(eventName, data) {
  return pubSub.publish(eventName, data);
}
